import { FormProps } from "react-hook-form";
import { TextEditor } from "@/ui/index";
import { FormControl, FormField, FormItem, FormMessage } from "@/ui/form";

type ReserveDescriptionProps = {
  form: FormProps<any>;
};

export function ReserveFieldDescription({ form }: ReserveDescriptionProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <TextEditor onChange={field.onChange} value={field.value} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
